var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.95,
    height: 27.95,
    viewBox: "0 0 27.95 27.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64730",
    "data-name": "Path 64730",
    d: "M13.092,18.858l2.883-2.883m0,0,2.883-2.883m-2.883,2.883-2.883-2.883m2.883,2.883,2.883,2.883M28.95,15.975A12.975,12.975,0,1,1,15.975,3,12.975,12.975,0,0,1,28.95,15.975Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossImg);
export default __webpack_public_path__ + "static/media/crossImg.a7454bea00abc277e68bcd607f89f5b5.svg";
export { ForwardRef as ReactComponent };